const EXTERNAL = /^([a-z]+:)/;
const ABSOLUTE_OPENSTAX = new RegExp(`(?:https?://openstax.org|${window.location.origin})(?!/(?:(?:.*/)?books|accounts|oxauth|blog-feed|documents)/)`);
const MAILTO = /^mailto:(.+)/;
function ignoreUrl(url) {
    return typeof url !== 'string' || MAILTO.test(url);
}
function ignoreClick(e) {
    return e.defaultPrevented || e.metaKey;
}
function validUrlClick(e) {
    var _a;
    const el = e.target.closest('a');
    const href = (_a = el === null || el === void 0 ? void 0 : el.getAttribute('href')) !== null && _a !== void 0 ? _a : null;
    if (ignoreClick(e) || ignoreUrl(href)) {
        return false;
    }
    return el;
}
function stripOpenStaxDomain(href) {
    return href.replace(ABSOLUTE_OPENSTAX, '');
}
function isExternal(href) {
    return EXTERNAL.test(href) && !ABSOLUTE_OPENSTAX.test(href);
}
function loginOrOutLink(loginOrLogout) {
    const encodedLocation = encodeURIComponent(decodeURIComponent(window.location.href));
    const { accountHref } = window.SETTINGS;
    return `${accountHref}/${loginOrLogout}/?r=${encodedLocation}`;
}
function loginLink() {
    return loginOrOutLink('login');
}
function logoutLink() {
    return loginOrOutLink('logout');
}
function setUtmCampaign(url, campaign) {
    try {
        const parsed = new URL(url);
        parsed.searchParams.set('utm_campaign', campaign);
        return parsed.toString();
    }
    catch (_a) {
        return url;
    }
}
export default {
    isExternal,
    validUrlClick,
    loginLink,
    logoutLink,
    stripOpenStaxDomain,
    setUtmCampaign
};
